import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import { useCurrentUserRole } from "../hooks/useCurrentUserRole";
import { useGovernanceActorProfile } from "../hooks/useGovernanceActorProfile";
import { mayManageOpenBankingIntegration } from "../lib/tenantUserAccess";

/**
 * Internal-only: tenant_admin, supervisor, or super_admin with explicit tenant context.
 */
export function OpenBankingIntegrationRoute() {
  const { session, user, loading: authLoading } = useAuth();
  const actorId = session?.user?.id ?? user?.id;
  const { role, isLoading: roleLoading, isError: roleError } = useCurrentUserRole(actorId);
  const { profile, isLoading: profileLoading, isError: profileError } = useGovernanceActorProfile(actorId);

  if (authLoading || roleLoading || profileLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-sm text-muted-foreground">Laden...</div>
    );
  }
  if (roleError || profileError) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-sm text-red-600">
        Kon gegevens niet laden.
      </div>
    );
  }
  if (!mayManageOpenBankingIntegration(role, profile)) {
    return <Navigate to="/app/explorer" replace />;
  }

  return <Outlet />;
}
